import { render } from "./ListDataTable.vue?vue&type=template&id=112b314b&scoped=true"
import script from "./ListDataTable.vue?vue&type=script&lang=js"
export * from "./ListDataTable.vue?vue&type=script&lang=js"

import "./ListDataTable.vue?vue&type=style&index=0&id=112b314b&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112b314b"]])

export default __exports__